import "./App.css";
import MainLogo from "./imgs/header.png";
import Form1 from "./components/Form1";
import Form2 from "./components/Form2";
import ThankYouPage from "./components/thank-you";
import { YouTube, Facebook, LinkedIn, Twitter } from "@mui/icons-material";
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

function App() {
  const [selectedTabColon, setSelectedTabColon] = useState(false);
  const [selectedTabSchedule, setSelectedTabSchedule] = useState(false);

  useEffect(() => {
    if (window.location.pathname === "/schedule-screening") {
      setSelectedTabSchedule((selectedTabSchedule) => !selectedTabSchedule);
    }
  }, []);

  useEffect(() => {
    if (window.location.pathname === "/colonoscopy-questionnaire") {
      setSelectedTabColon((selectedTabColon) => !selectedTabColon);
    }
  }, []);

  return (
    <Router>
      <nav className="forms-nav">
        <div className="top-bar">
          <div className="social-icons">
            <a
              href="https://youtube.com/playlist?list=PLNf2iXsn_MGW5Ro3gY5Bax7ptV6c6-P1u"
              target="_blank"
              rel="noreferrer"
            >
              <YouTube className="socialIcon" sx={{ color: "white" }} />
            </a>

            <a
              href="https://www.facebook.com/dr.yaminimaddalamd"
              target="_blank"
              rel="noreferrer"
            >
              <Facebook className="socialIcon" sx={{ color: "white" }} />
            </a>

            <a
              href="https://www.linkedin.com/in/yamini-maddala-87421414"
              target="_blank"
              rel="noreferrer"
            >
              <LinkedIn className="socialIcon" sx={{ color: "white" }} />
            </a>

            <a
              href="https://twitter.com/YaminiMaddala"
              rel="noreferrer"
              target="_blank"
            >
              <Twitter className="socialIcon" sx={{ color: "white" }} />
            </a>
          </div>

          <ul className="top-bar-links">
            <li className="dropdown">
              <a
                href="https://yaminimaddalamd.com/yamini-maddala-m-d/"
                target="_self"
                rel="noreferrer"
                className="dropdown-link"
              >
                About Us
              </a>
              <div class="dropdown-content">
                <a href="https://yaminimaddalamd.com/yamini-maddala-m-d/">Yamini Maddala, M.D.</a>
                <a href="https://yaminimaddalamd.com/office-staff/">Office & Staff</a>
              </div>
            </li>
            <li>
              <a
                href="https://yaminimaddalamd.com/contact-us/"
                target="_self"
                rel="noreferrer"
              >
                Contact Us
              </a>
            </li>
            <li>
              <a
                href="https://yaminimaddalamd.com/research/"
                target="_self"
                rel="noreferrer"
              >
                Research
              </a>
            </li>
            <li>
              <a
                href="https://yaminimaddalamd.com/awards-and-recognitions/"
                target="_self"
                rel="noreferrer"
              >
                Awards and Recognition’s
              </a>
            </li>
            <li>
              <a
                href="https://yaminimaddalamd.com/request-an-appointment/"
                target="_self"
                rel="noreferrer"
              >
                Request An Appointment
              </a>
            </li>
          </ul>
        </div>
        <div className="forms-nav-brand">
          <img src={MainLogo} alt="DHAT" className="forms-nav-img" />
        </div>
        <div className="nav-links">
          <ul className="nav-links-list">
            <li>
              <a
                href="https://yaminimaddalamd.com/"
                target="_self"
                rel="noreferrer"
              >
                Home
              </a>
            </li>

            <li className={selectedTabColon ? "selected-tab" : ""}>
              <a href="/colonoscopy-questionnaire">
                Colonoscopy Questionnaire{" "}
              </a>
            </li>
            <li className={selectedTabSchedule ? "selected-tab" : ""}>
              <a href="/schedule-screening">Schedule Screening</a>
            </li>
          </ul>
        </div>
      </nav>
      <Switch>
        <Route exact path="/colonoscopy-questionnaire" component={Form1}>
          <Form1 />
        </Route>
        <Route exact path="/schedule-screening" component={Form2}>
          <Form2 />
        </Route>
        <Route exact path="/thank-you" component={ThankYouPage}>
          <ThankYouPage />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
